import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

// Infobulle Bootstrap sur un élément qui peut arriver par n'importe quel
// chemin. L'initialiseur global (`initializeBootstrapComponents`) ne passe que
// sur `turbo:frame-load` : un fragment remplacé par Turbo Stream — la carte
// Match(s) après une qualification — n'était jamais équipé, et l'infobulle
// restait muette. `connect` de Stimulus, lui, se déclenche à chaque entrée
// dans le DOM, quelle qu'en soit la cause.
export default class extends Controller {
  connect() {
    this.tooltip = Tooltip.getOrCreateInstance(this.element)
  }

  disconnect() {
    this.tooltip?.dispose()
    this.tooltip = null
  }
}
